import { Component, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BauherrHelper } from '../../../core/helper/bauherr.helper';
import { ProjektDto } from '../../../core/models/projekt/projekt-dto.model';
import { DashboardCardComponent } from '../../dashboard/dashboardcard.component';

@Component({
  selector: 'bpw-pr-dashboardcard',
  standalone: true,
  imports: [RouterModule],
  templateUrl: './pr-dashboardcard.component.html',
  styleUrls: ['./pr-dashboardcard.component.scss'],
})
export class PrDashboardcardComponent implements DashboardCardComponent {
  @Input()
  public data: any;
  public visible: boolean;

  constructor() {
    this.visible = false;
  }

  public getBauherr(projekt: ProjektDto): string {
    return BauherrHelper.getBauherrByProjektDto(projekt) ?? '';
  }
}
